import { useContent } from "@/context/ContentContext";
import { resolveImg } from "@/lib/api";

const VEIL =
  "linear-gradient(180deg,rgba(13,13,13,.45) 0%,rgba(13,13,13,.1) 35%,rgba(13,13,13,.55) 65%,rgba(13,13,13,.92) 100%)";

export const Hero = () => {
  const { hero } = useContent();

  return (
    <section id="hero" className="bleed hero" data-testid="hero">
      {hero?.background_url && (
        <img src={resolveImg(hero.background_url)} alt="" style={{ objectPosition: "50% 40%" }} />
      )}
      <div className="veil" style={{ background: VEIL }} />
      {hero?.sticker_value && (
        <div className="sticker" data-testid="hero-sticker">
          <div>
            <b>{hero.sticker_value}</b>
            <span>{hero.sticker_label}</span>
          </div>
        </div>
      )}
      <div className="in wrap">
        <p className="lb">{hero?.eyebrow}</p>
        <h1 className="h" style={{ marginTop: 20, maxWidth: 1100, fontSize: "clamp(44px,6.4vw,112px)" }} data-testid="hero-title">
          {hero?.tagline_1} <span className="ac">{hero?.tagline_accent}</span>
        </h1>
        <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "space-between", alignItems: "flex-end", gap: 32, marginTop: 40 }}>
          <p className="lead">{hero?.description}</p>
          <div className="btns">
            <a href="#contacto" className="btn fill" data-testid="hero-cta-primary">{hero?.cta_primary}</a>
            <a href="#casos" className="btn" data-testid="hero-cta-secondary">{hero?.cta_secondary}</a>
          </div>
        </div>
      </div>
    </section>
  );
};
